import { render, staticRenderFns } from "./MarginRecharge.vue?vue&type=template&id=96fedc66&scoped=true&"
import script from "./MarginRecharge.vue?vue&type=script&lang=js&"
export * from "./MarginRecharge.vue?vue&type=script&lang=js&"
import style0 from "./MarginRecharge.vue?vue&type=style&index=0&id=96fedc66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fedc66",
  null
  
)

export default component.exports